import { Injectable } from '@angular/core';
import { FieldConfig } from 'hig-ng-lib';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MenuService {
    public menuHeading: Subject<FieldConfig> = new Subject<FieldConfig>();
    public menuHeadingChanged$: Observable<FieldConfig> = this.menuHeading.asObservable();
}
